import { useMutation, useQueryClient } from "@tanstack/react-query";

import { newConversationCreationService } from "../../services/conversationServices";

/**
 * Creates a new conversation on the backend and invalidates the
 * sidebar list so the new entry shows up. The optimistic cache write
 * for the active conversation lives in the composition root because
 * it depends on the *previous* active conversation, which this hook
 * doesn't read.
 */
export function useNewConversation({ clientId }) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: async (contentToSend) => {
      const newConvId = await newConversationCreationService(
        { name: contentToSend.substring(0, 40) },
        clientId,
      );
      await queryClient.invalidateQueries({
        queryKey: ["conversation-list", clientId],
      });
      return newConvId;
    },
  });

  return { create: mutateAsync, isPending, error };
}
